/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Automatic_Save_Completed_SuccessInputs */

const en_automatic_save_completed_success = /** @type {(inputs: Automatic_Save_Completed_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatic save completed successfully`)
};

const fr_automatic_save_completed_success = /** @type {(inputs: Automatic_Save_Completed_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sauvegarde automatique terminée avec succès`)
};

const de_automatic_save_completed_success = /** @type {(inputs: Automatic_Save_Completed_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatisches Speichern erfolgreich abgeschlossen`)
};

const it_automatic_save_completed_success = /** @type {(inputs: Automatic_Save_Completed_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salvataggio automatico completato con successo`)
};

const ru_automatic_save_completed_success = /** @type {(inputs: Automatic_Save_Completed_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Автоматическое сохранение успешно завершено.`)
};

const es_automatic_save_completed_success = /** @type {(inputs: Automatic_Save_Completed_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guardado automático completado exitosamente`)
};

const zh_cn2_automatic_save_completed_success = /** @type {(inputs: Automatic_Save_Completed_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自动保存已成功完成`)
};

const ja_automatic_save_completed_success = /** @type {(inputs: Automatic_Save_Completed_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自動保存が正常に完了しました`)
};

const hi_automatic_save_completed_success = /** @type {(inputs: Automatic_Save_Completed_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्वचालित सेव सफलतापूर्वक पूरा हो गया`)
};

const pt_pt2_automatic_save_completed_success = /** @type {(inputs: Automatic_Save_Completed_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salvamento automático concluído com sucesso.`)
};

/**
* | output |
* | --- |
* | "Automatic save completed successfully" |
*
* @param {Automatic_Save_Completed_SuccessInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const automatic_save_completed_success = /** @type {((inputs?: Automatic_Save_Completed_SuccessInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automatic_Save_Completed_SuccessInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_automatic_save_completed_success(inputs)
	if (locale === "de") return de_automatic_save_completed_success(inputs)
	if (locale === "it") return it_automatic_save_completed_success(inputs)
	if (locale === "ru") return ru_automatic_save_completed_success(inputs)
	if (locale === "es") return es_automatic_save_completed_success(inputs)
	if (locale === "zh-CN") return zh_cn2_automatic_save_completed_success(inputs)
	if (locale === "ja") return ja_automatic_save_completed_success(inputs)
	if (locale === "hi") return hi_automatic_save_completed_success(inputs)
	if (locale === "pt-PT") return pt_pt2_automatic_save_completed_success(inputs)
	return en_automatic_save_completed_success(inputs)
});